'use client';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  position: absolute;
  left: 0;
  top: calc(100% + 4px);
  z-index: ${({ theme }) => theme.zIndices.searchBar};
  display: flex;
  min-width: 416px;
  align-items: flex-start;
  padding-bottom: 24px;
  border-radius: 12px;
  background: ${({ theme }) => theme.palette.white};
  color: ${({ theme }) => theme.palette.grey1100};
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);
`;

export default Wrapper;
